import React, { Component } from 'react';
import { Button, Form, Row, Col, Image } from 'react-bootstrap';
import axios from 'axios';
import './SellProduct.css';
import { getAuth } from 'firebase/auth';

class SellProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      category: '',
      brand: '',
      quantity: 1,
      price: '',
      description: '',
      productImage: null,
      productCondition: 'new',
      color: '',
      size: '',
      username: '',
    };
  }

  componentDidMount() {
    // Récupérer l'utilisateur connecté depuis localStorage ou Firebase
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      this.setState({ username: user.name });
    } else {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (currentUser) {
        this.setState({
          username: currentUser.displayName || currentUser.email,
        });
      }
    }
  }

  handleImageUpload = (e) => {
    if (e.target.files.length) {
      const file = e.target.files[0];
      this.setState({ productImage: file });
    }
  };

  handleImageClick = () => {
    const fileInput = document.getElementById('image-upload');
    if (fileInput) {
      fileInput.click();
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
  
    const {
      name,
      category,
      brand,
      quantity,
      price,
      description,
      productImage,
      productCondition,
      color,
      size,
      username,
    } = this.state;
  
    const productData = {
      name,
      category,
      brand,
      quantity,
      price,
      description,
      productCondition,
      color,
      size,
      username,
    };
    
    const formData = new FormData();
    formData.append("productData", JSON.stringify(productData));
    if (productImage) {
      formData.append("productImage", productImage);
    }
    
  
    console.log([...formData.entries()]); // Affiche toutes les données envoyées au serveur
  
    try {
      const response = await axios.post('http://localhost:5000/api/products/add', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      if (response.status === 201) {
        alert('Produit ajouté avec succès !');
        this.setState({
          name: '',
          category: '',
          brand: '',
          quantity: 1,
          price: '',
          description: '',
          productImage: null,
          productCondition: 'new',
          color: '',
          size: '',
          username: '',
        });
      } else {
        alert('Erreur lors de l\'ajout du produit');
      }
    } catch (error) {
      console.error('Erreur lors de l\'ajout du produit', error);
      alert('Erreur lors de l\'ajout du produit');
    }
  };
  

  render() {
    const {
      name,
      category,
      brand,
      quantity,
      price,
      description,
      productImage,
      productCondition,
      color,
      size,
    } = this.state;

    return (
      <div style={{ marginTop: '80px' }}>
        <Form onSubmit={this.handleSubmit} className="sell-product-form">
          <Row>
            <Col md={4}>
              <div
                className="image-upload-section"
                onClick={this.handleImageClick}
                style={{
                  border: '2px dashed #007bff',
                  padding: '20px',
                  textAlign: 'center',
                  cursor: 'pointer',
                }}
              >
                {productImage ? (
                  <Image
                    src={URL.createObjectURL(productImage)}
                    fluid
                    className="product-image-preview"
                    alt="Product Preview"
                    style={{ cursor: 'pointer' }}
                  />
                ) : (
                  <span>Ajouter l'image de l'article</span>
                )}
                <input
                  type="file"
                  id="image-upload"
                  onChange={this.handleImageUpload}
                  accept="image/*"
                  hidden
                />
              </div>
            </Col>
            <Col md={8}>
              <Form.Group controlId="name">
                <Form.Label>Nom du produit</Form.Label>
                <Form.Control
                  type="text"
                  value={name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  placeholder="Enter product name"
                  required
                />
              </Form.Group>

              <Form.Group controlId="category">
                <Form.Label>Catégories</Form.Label>
                <Form.Control
                  as="select"
                  value={category}
                  onChange={(e) => {
                    this.setState({ category: e.target.value });
                    if (e.target.value !== 'Vêtements') {
                      this.setState({ size: '' });
                    }
                  }}
                  required
                >
                  <option value="">Choisir la catégorie</option>
                  <option value="Electronique">Electronique</option>
                  <option value="Cuisine">Cuisine</option>
                  <option value="Soins et Beauté">Soins et Beauté</option>
                  <option value="Vêtements">Vêtements</option>
                  <option value="Téléphones et Tablette">Téléphones et Tablettes</option>
                  <option value="Maison et Bureau">Maison et Bureau</option>
                </Form.Control>
              </Form.Group>

              <Form.Group controlId="brand">
                <Form.Label>Marque</Form.Label>
                <Form.Control
                  type="text"
                  value={brand}
                  onChange={(e) => this.setState({ brand: e.target.value })}
                  placeholder="Enter brand name"
                />
              </Form.Group>

              <Form.Group controlId="quantity">
                <Form.Label>Quantité</Form.Label>
                <Form.Control
                  type="number"
                  value={quantity}
                  onChange={(e) => this.setState({ quantity: e.target.value })}
                  min="1"
                  required
                />
              </Form.Group>

              <Form.Group controlId="productCondition">
                <Form.Label>Condition</Form.Label>
                <Form.Control
                  as="select"
                  value={productCondition}
                  onChange={(e) => this.setState({ productCondition: e.target.value })}
                  required
                >
                  <option value="new">Nouveau</option>
                  <option value="used">Ancien</option>
                </Form.Control>
              </Form.Group>

              <Form.Group controlId="color">
                <Form.Label>Couleur</Form.Label>
                <Form.Control
                  type="text"
                  value={color}
                  onChange={(e) => this.setState({ color: e.target.value })}
                  placeholder="Enter color"
                />
              </Form.Group>

              {category === 'Vêtements' && (
                <Form.Group controlId="size">
                  <Form.Label>Taille</Form.Label>
                  <Form.Control
                    type="text"
                    value={size}
                    onChange={(e) => this.setState({ size: e.target.value })}
                    placeholder="Enter size"
                  />
                </Form.Group>
              )}

              <Form.Group controlId="price">
                <Form.Label>Prix</Form.Label>
                <Form.Control
                  type="number"
                  value={price}
                  onChange={(e) => this.setState({ price: e.target.value })}
                  placeholder="Enter product price"
                  required
                />
              </Form.Group>

              <Form.Group controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  value={description}
                  onChange={(e) => this.setState({ description: e.target.value })}
                  placeholder="Enter product description"
                  required
                  rows={3}
                />
              </Form.Group>
            </Col>
          </Row>
          <center>
            <Button type="submit">Ajouter</Button>
            <Button
              type="reset"
              onClick={() =>
                this.setState({
                  name: '',
                  category: '',
                  brand: '',
                  quantity: 1,
                  price: '',
                  description: '',
                  productImage: null,
                  productCondition: 'new',
                  color: '',
                  size: '',
                })
              }
            >
              Annuler
            </Button>
          </center>
        </Form>
      </div>
    );
  }
}

export default SellProduct;
